import React, { useMemo } from "react";
import { Box, Flex, Heading, Text, BoxProps } from "@chakra-ui/react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from "next-i18next";

import { Product } from "../../types/product";
import ProductCard from "@/components/Product/ProductCard";
import useDeviceSize from "@/utils/useDeviceSize";

type Props = {
  products: Product[];
  variant?: "green" | "blue";
  title?: string;
  subtitle?: string;
  showGarageDistance?: boolean;
};

const ProductsSlider = ({
  products,
  variant = "green",
  title,
  subtitle,
  showGarageDistance = true,
  ...props
}: Props & BoxProps): React.ReactElement => {
  const [width] = useDeviceSize()
  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: (width >= 1500 && products?.length < 5) || (width < 1500 && products?.length < 4) ? products?.length : (width >= 1500 ? 5 : 4),
    slidesToScroll: 1,
  };
  const gradient = useMemo(() => {
    if (variant === "green")
      return "linear-gradient(45deg, #27ae60 0%, #1e8449 100%)";
    if (variant === "blue")
      return "linear-gradient(45deg, #2980b9 0%, #20638f 100%)";
  }, [variant]);
  const textVariant = variant === "green" ? "green" : "white";

  return (
    <Box bg={gradient} {...props}>
      <Box className="main-container" px={{ base: "15px", sm: "50px", xl: 0 }} mx="auto" py="50px">
        <Flex mb={10} flexDirection="column">
          {title && (
            <Heading size="md" variant={textVariant} my={0} mr={3}>
              {title}
            </Heading>
          )}
          {subtitle && (
            <Text color="gray.200" fontStyle="italic" fontSize="md">
              {subtitle}
            </Text>
          )}
        </Flex>
        <Slider {...sliderSettings}>
          {products?.map((product, index) => (
            <ProductCard product={product} key={index}/>
          ))}
        </Slider>
      </Box>
    </Box>
  );
};

export default ProductsSlider;
